module.exports = __webpack_public_path__ + "static/media/daily-pricing-icon.f9f77b34.svg";